/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Preview_EmptyInputs */

const cs_builder_preview_empty = /** @type {(inputs: Builder_Preview_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klikněte na Náhled pro kompilaci PDF. Editace zůstává na plátně.`)
};

const en_builder_preview_empty = /** @type {(inputs: Builder_Preview_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click Preview to compile a PDF. Editing stays on the canvas.`)
};

/**
* | output |
* | --- |
* | "Click Preview to compile a PDF. Editing stays on the canvas." |
*
* @param {Builder_Preview_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_preview_empty = /** @type {((inputs?: Builder_Preview_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Preview_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_preview_empty(inputs)
	return cs_builder_preview_empty(inputs)
});